export default import.meta.ROLLDOWN_FILE_URL_9338h9Hetis98yjyuFVdVw